import { Contact } from '@wonderschool/common-base-types';

export function getAmountDue(selectedInvoice, deductProcessingFees) {
  const processingFeeItem = selectedInvoice.invoiceItemList.find((item) => item.processingFees !== undefined);
  if (deductProcessingFees && processingFeeItem) {
    const processingFeeAmount = processingFeeItem ? processingFeeItem.amount : 0;
    const totalBeforeProcessingFees = selectedInvoice.total - processingFeeAmount;
    return totalBeforeProcessingFees - getPaidAmount(selectedInvoice, deductProcessingFees);
  }
  return selectedInvoice.total - getPaidAmount(selectedInvoice, deductProcessingFees);
}

export function getInvoiceTotal(selectedInvoice, deductProcessingFees) {
  if (deductProcessingFees) {
    const processingFeeItem = selectedInvoice.invoiceItemList.find((item) => item.processingFees !== undefined);
    const processingFeeAmount = processingFeeItem ? processingFeeItem.amount : 0;
    return selectedInvoice.totalBeforeProcessingFees || selectedInvoice.total - processingFeeAmount;
  }

  return selectedInvoice.total;
}

export function getPaidAmount(selectedInvoice, deductProcessingFees) {
  const processingFeeItem = selectedInvoice.invoiceItemList.find((item) => item.processingFees !== undefined);

  if (deductProcessingFees && processingFeeItem && selectedInvoice.paidAmount === selectedInvoice.total) {
    //only discount processing fee if invoice is fully paid
    return selectedInvoice.total - processingFeeItem.amount;
  }
  return selectedInvoice.paidAmount ?? 0;
}

export function getResponsibleForBilling(student): Contact | null {
  return student && student.responsibleForBilling ? student.responsibleForBilling : null;
}

export function DetailCard({ title, children }) {
  return (
    <div className="grid grid-cols-1 gap-y-1 divide-y-2 rounded-md border border-gray-300 px-2 py-4 sm:px-4">
      <h2>{title}</h2>
      <div className="grid grid-cols-1 gap-2 text-base">{children}</div>
    </div>
  );
}
